import { Box } from '@mui/system'
import React, { PropsWithChildren } from 'react'
import { CircularProgress } from '@mui/material'

type LoadingWrapperProps = {
  isLoading: boolean
}

const LoadingWrapper = ({ children, isLoading = true }: PropsWithChildren<LoadingWrapperProps>) => {
  return (
    <Box position="relative" width="100%" height="100%">
      {isLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={2}
        >
          <CircularProgress />
        </Box>
      )}
      <Box
        sx={{
          opacity: isLoading ? 0.5 : 1,
          pointerEvents: isLoading ? 'none' : 'auto',
          width: '100%',
          height: '100%'
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default LoadingWrapper
